import { useState } from 'react'

import {
  useTherapistSessionLocationFilter,
  type UseTherapistSessionLocationFilter,
} from './TherapistSessionLocationFilter.hooks'
import { TherapistSessionLocationFilterUI } from './TherapistSessionLocationFilter.ui'

export interface TherapistSessionLocationFilterProps extends UseTherapistSessionLocationFilter {}

export const TherapistSessionLocationFilter = (props: TherapistSessionLocationFilterProps) => {
  const [region, setRegion] = useState<string>()

  const { value, handleChange, data } = useTherapistSessionLocationFilter(props)

  if (data === undefined) {
    return null
  }

  return (
    <TherapistSessionLocationFilterUI
      region={region}
      onRegionChange={setRegion}
      checked={value}
      onCheckedChange={handleChange}
      districts={data}
    />
  )
}
